import { NativeSelect } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import * as React from "react";
import { QueryFilter } from "./Interface.helper";

interface ComboBoxQueryParams {
  queryFilter: QueryFilter[];
  defaultValue?: QueryFilter;
  selectedValue: (e: any) => void;
}

const ComboBoxQuery: React.FC<ComboBoxQueryParams> = ({
  queryFilter,
  selectedValue,
  defaultValue,
}) => {
  const [query, setQuery] = React.useState("");

  const handleChange = (event: {
    target: { value: React.SetStateAction<string> };
  }) => {
    setQuery(event.target.value);
    selectedValue(event.target.value);
  };

  return (
    <FormControl sx={{ m: 1, minWidth: 160, width: "95%" }} size="small">
{/*       <InputLabel variant="standard" htmlFor="uncontrolled-native">
        Query
      </InputLabel> */}
      <NativeSelect
        id="demo-select-small"
        defaultValue={defaultValue}
        value={query}
        inputProps={{
          name: "value",
          id: "uncontrolled-native",
        }}
        onChange={handleChange}
      >
        {queryFilter.map((item, index) => {
          return <option key={index} value={item.key}> {item.value}</option>;
        })}
      </NativeSelect>
    </FormControl>
  );
};

export default ComboBoxQuery;
